import { completedComics } from "@/mocks/comics";

export default function CompletedZone() {
  return (
    <section id="completed" className="scroll-mt-28 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
              <i className="ri-checkbox-circle-line text-sm" aria-hidden="true"></i>
              完结专区 · 全集打包
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">已完结作品与全集下载入口</h2>
            <p className="mt-2 max-w-[660px] text-sm leading-relaxed text-foreground-600">
              这里只放已经画完的作品：目录一次给全，进度不再中断。喜欢一口气读完的读者，可以直接从「全集打包」
              进入整理好的完整话数，也可以先在线阅读几话再决定。
            </p>
          </div>
          <span className="hidden items-center gap-2 rounded-md bg-background-50 px-3 py-2 text-xs text-foreground-600 md:inline-flex">
            <i className="ri-information-line text-secondary-600" aria-hidden="true"></i>
            打包内容按完结话数整理，不含番外单行
          </span>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {completedComics.map((comic) => (
            <article
              key={comic.id}
              className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="flex gap-3 p-3">
                <div className="h-[150px] w-[107px] shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={comic.cover}
                    alt={`《${comic.title}》完结封面插画`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col">
                  <h3 className="truncate font-heading text-base text-foreground-950">{comic.title}</h3>
                  <p className="mt-1 text-xs text-foreground-500">
                    {comic.author} · {comic.genre}
                  </p>
                  <div className="mt-2 flex flex-wrap gap-1.5">
                    {comic.tags.map((tag) => (
                      <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-foreground-500">
                    <span className="inline-flex items-center gap-1 font-medium text-accent-800">
                      <i className="ri-archive-drawer-line" aria-hidden="true"></i>
                      {comic.progress}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-fire-line" aria-hidden="true"></i>
                      {comic.heat} 收藏
                    </span>
                  </div>
                </div>
              </div>

              <p className="px-3 text-xs leading-relaxed text-foreground-600">{comic.summary}</p>

              <div className="mt-3 flex items-center gap-2 border-t border-background-200 p-3">
                <a
                  href="#latest"
                  className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-md bg-primary-500 px-3 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  <i className="ri-download-2-line text-base" aria-hidden="true"></i>
                  全集打包
                </a>
                <a
                  href="#latest"
                  className="inline-flex items-center justify-center gap-1.5 rounded-md border border-background-300 px-3 py-2 text-sm text-foreground-700 hover:border-accent-400 hover:text-accent-800 transition-colors whitespace-nowrap"
                >
                  <i className="ri-book-open-line text-base" aria-hidden="true"></i>
                  在线阅读
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}